var _path, _path2, _path3, _path4, _path5, _path6, _mask, _rect, _rect2, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32227 36.1928V2.29148L8.2556 1L28.2334 1.32287V6.81166L29.2 7.78027L34.6778 8.10314L35 8.42601V35.2242L34.0334 36.8386L6.32227 36.1928Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2334 6.81192V1.96887L28.5556 1.646L34.6778 7.45766V8.1034H31.4556L29.2001 7.78053L28.2334 6.81192Z",
    fill: "#FAFBFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7.9414V33.9997C35 35.6565 33.6569 36.9997 32 36.9997H9C7.34315 36.9997 6 35.6565 6 33.9997V4.16113C6 2.50428 7.34315 1.16113 9 1.16113H28.2333M35 7.9414L28.2333 1.16113M35 7.9414H31.2333C29.5765 7.9414 28.2333 6.59826 28.2333 4.9414V1.16113",
    stroke: "#DFE0EB",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1501 20.5337H21.3057",
    stroke: "#DFE0EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1501 24.1504H22.9168",
    stroke: "#DFE0EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1501 22.3418H24.5279",
    stroke: "#DFE0EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_10789_228556",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.3445,
    y: 13.4302,
    width: 10.3111,
    height: 5.16592,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3445,
    y: 13.4302,
    width: 10.3111,
    height: 5.16592,
    rx: 1,
    stroke: "#DFE0EB",
    strokeWidth: 2.5,
    mask: "url(#path-7-inside-1_10789_228556)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 26,
    height: 12,
    rx: 3,
    fill: "#F03738"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0116 32.662C10.0116 32.998 9.93057 33.313 9.76857 33.607C9.61257 33.901 9.36357 34.138 9.02157 34.318C8.68557 34.498 8.25957 34.588 7.74357 34.588H6.69057V37H5.43057V30.718H7.74357C8.22957 30.718 8.64357 30.802 8.98557 30.97C9.32757 31.138 9.58257 31.369 9.75057 31.663C9.92457 31.957 10.0116 32.29 10.0116 32.662ZM7.68957 33.571C8.03757 33.571 8.29557 33.493 8.46357 33.337C8.63157 33.175 8.71557 32.95 8.71557 32.662C8.71557 32.05 8.37357 31.744 7.68957 31.744H6.69057V33.571H7.68957ZM13.1022 30.718C13.7622 30.718 14.3412 30.847 14.8392 31.105C15.3432 31.363 15.7302 31.732 16.0002 32.212C16.2762 32.686 16.4142 33.238 16.4142 33.868C16.4142 34.498 16.2762 35.05 16.0002 35.524C15.7302 35.992 15.3432 36.355 14.8392 36.613C14.3412 36.871 13.7622 37 13.1022 37H10.9062V30.718H13.1022ZM13.0572 35.929C13.7172 35.929 14.2272 35.749 14.5872 35.389C14.9472 35.029 15.1272 34.522 15.1272 33.868C15.1272 33.214 14.9472 32.704 14.5872 32.338C14.2272 31.966 13.7172 31.78 13.0572 31.78H12.1662V35.929H13.0572ZM21.2363 30.718V31.735H18.6173V33.346H20.6243V34.345H18.6173V37H17.3573V30.718H21.2363Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePdf);
export default __webpack_public_path__ + "static/media/icon-file-pdf.401275fe6c9a508edf330810be7a6f17.svg";
export { ForwardRef as ReactComponent };